import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-professional-bodies-bpams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-professional-bodies-bpams.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../app-controller.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { ViewApplicationProfessionalBodiesBpamsConstants } from "./view-application-professional-bodies-bpams.constants";
import { AlertType } from "../../../../shared/models/alert";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { ViewApplicationConstants } from "../../../shared/view-application.constants";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
let ViewApplicationProfessionalBodiesBpamsComponent = class ViewApplicationProfessionalBodiesBpamsComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    changeDetectorRef;
    routerParamsService;
    professionalBodiesForm;
    componentName = "view-application-professional-bodes";
    stepHeader;
    markArchitectAsNotApplicableLabel = ViewApplicationProfessionalBodiesBpamsConstants.MARK_ARCHITECT_AS_NOT_APPLICABLE_LABEL;
    markArchitectAsNotApplicableFormControlName = ViewApplicationProfessionalBodiesBpamsConstants.MARK_ARCHITECT_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    markEngineerAsNotApplicableLabel = ViewApplicationProfessionalBodiesBpamsConstants.MARK_ENGINEER_AS_NOT_APPLICABLE_LABEL;
    markEngineerAsNotApplicableFormControlName = ViewApplicationProfessionalBodiesBpamsConstants.MARK_ENGINEER_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    markElectricalContractorAsNotApplicableLabel = ViewApplicationProfessionalBodiesBpamsConstants.MARK_ELECTRICAL_CONTRACTOR_AS_NOT_APPLICABLE_LABEL;
    markElectricalContractorAsNotApplicableFormControlName = ViewApplicationProfessionalBodiesBpamsConstants.MARK_ELECTRICAL_CONTRACTOR_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    markFireConsultantAsNotApplicableLabel = ViewApplicationProfessionalBodiesBpamsConstants.MARK_FIRE_CONSULTANT_AS_NOT_APPLICABLE_LABEL;
    markFireConsultantAsNotApplicableFormControlName = ViewApplicationProfessionalBodiesBpamsConstants.MARK_FIRE_CONSULTANT_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    markOtherProfessionalAsNotApplicableLabel = ViewApplicationProfessionalBodiesBpamsConstants.MARK_OTHER_PROFESSIONAL_AS_NOT_APPLICABLE_LABEL;
    markOtherProfessionalAsNotApplicableFormControlName = ViewApplicationProfessionalBodiesBpamsConstants.MARK_OTHER_PROFESSIONAL_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    architectFormControlName = ViewApplicationProfessionalBodiesBpamsConstants.ARCHITECT_FORM_CONTROL_NAME;
    engineerFormControlName = ViewApplicationProfessionalBodiesBpamsConstants.ENGINEER_FORM_CONTROL_NAME;
    contractorFormControlName = ViewApplicationProfessionalBodiesBpamsConstants.ELECTRICAL_CONTRACTOR_FORM_CONTROL_NAME;
    fireConsultantFormControlName = ViewApplicationProfessionalBodiesBpamsConstants.FIRE_CONSULTANT_FORM_CONTROL_NAME;
    otherProfessionalFormControlName = ViewApplicationProfessionalBodiesBpamsConstants.OTHER_PROFESSIONAL_FORM_CONTROL_NAME;
    showArchitect = false;
    showEngineer = false;
    showElectricalContractor = false;
    showFireConsultant = false;
    showOtherProfessional = false;
    architectDisableFilterBy = true;
    architectDisableEditing = true;
    architectGroups = [];
    architectLabel = ViewApplicationProfessionalBodiesBpamsConstants.ARCHITECT_LABEL;
    engineerDisableFilterBy = true;
    engineerDisableAdd = true;
    engineerDisableEditing = true;
    engineerShowFields = true;
    engineerIsInternal = false;
    engineerGroups = [];
    engineerLabel = ViewApplicationProfessionalBodiesBpamsConstants.ENGINEER_LABEL;
    fireConsultantDisableFilterBy = true;
    fireConsultantDisableAdd = true;
    fireConsultantDisableEditing = true;
    fireConsultantShowFields = true;
    fireConsultantIsInternal = false;
    fireConsultantGroups = [];
    fireConsultantLabel = ViewApplicationProfessionalBodiesBpamsConstants.FIRE_CONSULTANT_LABEL;
    otherProfessionalDisableFilterBy = true;
    otherProfessionalDisableAdd = true;
    otherProfessionalDisableEditing = true;
    otherProfessionalShowFields = true;
    otherProfessionalIsInternal = false;
    otherProfessionalGroups = [];
    otherProfessionalLabel = ViewApplicationProfessionalBodiesBpamsConstants.OTHER_PROFESSIONAL_LABEL;
    contractorDisableFilterBy = true;
    contractorDisableAdd = true;
    contractorDisableEditing = true;
    contractorShowFields = true;
    contractorIsInternal = false;
    contractorGroups = [];
    contractorLabel = ViewApplicationProfessionalBodiesBpamsConstants.ELECTRICAL_CONTRACTOR_LABEL;
    selectedApplicationSubscription;
    selectedModuleNameAsObservableSubscription;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, appController, changeDetectorRef, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.changeDetectorRef = changeDetectorRef;
        this.routerParamsService = routerParamsService;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        this.subscribeToSelectedModuleName();
        this.listenForRouteParamChange();
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("professionalBodiesForm");
        form.clearValidators();
        this.professionalBodiesForm = form;
    }
    loadMetadata(stepMeta) {
        try {
            this.architectGroups = stepMeta.architectGroup;
            this.engineerGroups = stepMeta.engineerGroup;
            this.contractorGroups = stepMeta.electricalContractorGroup;
            this.fireConsultantGroups = stepMeta.fireConsultantGroup;
            this.otherProfessionalGroups = stepMeta.otherProfessionalGroup;
            this.populateProfessionalBodiesForms();
            this.changeDetectorRef.markForCheck();
        }
        catch (e) {
            this.appController.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    handleRouteChange() {
    }
    populateProfessionalBodiesForms() {
        this.selectedApplicationSubscription = this.selectedApplicationService.$selectedApplication.subscribe({
            next: (application) => {
                if (application && application.architect !== undefined && application.architect !== null && application.architect.length > 0) {
                    this.showArchitect = true;
                    const architect = application.architect[0];
                    this.professionalBodiesForm.get(this.architectFormControlName).setValue(architect);
                    this.professionalBodiesForm.markAllAsTouched();
                    this.professionalBodiesForm.get(this.architectFormControlName).disable();
                }
                else {
                    this.professionalBodiesForm.markAllAsTouched();
                    this.professionalBodiesForm.get(this.architectFormControlName).disable();
                }
                if (application && application.engineer !== undefined && application.engineer !== null && application.engineer.length > 0) {
                    this.showEngineer = true;
                    const engineer = application.engineer[0];
                    this.professionalBodiesForm.get(this.engineerFormControlName).setValue(engineer);
                    this.professionalBodiesForm.markAllAsTouched();
                    this.professionalBodiesForm.get(this.engineerFormControlName).disable();
                }
                else {
                    this.professionalBodiesForm.markAllAsTouched();
                    this.professionalBodiesForm.get(this.engineerFormControlName).disable();
                }
                if (application && application.electricalContractor !== undefined && application.electricalContractor !== null && application.electricalContractor.length > 0) {
                    this.showElectricalContractor = true;
                    const electricalContractor = application.electricalContractor[0];
                    this.professionalBodiesForm.get(this.contractorFormControlName).setValue(electricalContractor);
                    this.professionalBodiesForm.markAllAsTouched();
                    this.professionalBodiesForm.get(this.contractorFormControlName).disable();
                }
                else {
                    this.professionalBodiesForm.markAllAsTouched();
                    this.professionalBodiesForm.get(this.contractorFormControlName).disable();
                }
                if (application && application.fireConsultant !== undefined && application.fireConsultant !== null && application.fireConsultant.length > 0) {
                    this.showFireConsultant = true;
                    const fireConsultant = application.fireConsultant[0];
                    this.professionalBodiesForm.get(this.fireConsultantFormControlName).setValue(fireConsultant);
                    this.professionalBodiesForm.markAllAsTouched();
                    this.professionalBodiesForm.get(this.fireConsultantFormControlName).disable();
                }
                else {
                    this.professionalBodiesForm.markAllAsTouched();
                    this.professionalBodiesForm.get(this.fireConsultantFormControlName).disable();
                }
                if (application && application.otherProfessional !== undefined && application.otherProfessional !== null && application.otherProfessional.length > 0) {
                    this.showOtherProfessional = true;
                    const otherProfessional = application.otherProfessional[0];
                    this.professionalBodiesForm.get(this.otherProfessionalFormControlName).setValue(otherProfessional);
                    this.professionalBodiesForm.markAllAsTouched();
                    this.professionalBodiesForm.get(this.otherProfessionalFormControlName).disable();
                }
                else {
                    this.professionalBodiesForm.markAllAsTouched();
                    this.professionalBodiesForm.get(this.otherProfessionalFormControlName).disable();
                }
            }
        });
    }
    subscribeToSelectedModuleName() {
        this.selectedModuleNameAsObservableSubscription = this.applicationViewService.selectedModuleNameAsObservable.subscribe((modName) => {
            const header = `${ViewApplicationConstants.PROFESSIONAL_BODIES_HEADING}`;
            this.stepHeader = header[0].toUpperCase() + header.substr(1).toLowerCase();
            this.changeDetectorRef.markForCheck();
        });
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
};
ViewApplicationProfessionalBodiesBpamsComponent = __decorate([
    Component({
        selector: "app-view-application-professional-bodies-bpams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationProfessionalBodiesBpamsComponent);
export { ViewApplicationProfessionalBodiesBpamsComponent };
